import { cn } from "@/utils";

import { LazyMotion, domAnimation, m } from "framer-motion";

const Loader = ({ size, className = "", color }) => {
  if (size === "small") {
    return (
      <LazyMotion features={domAnimation}>
        <span
          className={cn(
            "flex items-center justify-center",
            color === "white" && "text-white",
            className
          )}
        >
          <span
            className="relative size-4"
            role="status"
            aria-label="Chargement"
          >
            <m.span
              className="absolute inset-0 rounded-full border border-current border-r-transparent border-b-transparent"
              animate={{ rotate: 360 }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
            />
            <m.span
              className="border-secondary-contrast absolute inset-[3px] rounded-full border border-t-transparent border-l-transparent"
              animate={{ rotate: -360 }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
            />
          </span>
        </span>
      </LazyMotion>
    );
  }

  return (
    <LazyMotion features={domAnimation}>
      <span className={cn("m-20 flex items-center justify-center", className)}>
        <span
          className="relative size-12"
          role="status"
          aria-label="Chargement"
        >
          <m.span
            className="border-primary absolute inset-0 rounded-full border-2 border-r-transparent border-b-transparent"
            animate={{ rotate: 360 }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          />
          <m.span
            className="border-secondary-contrast absolute inset-2 rounded-full border-2 border-t-transparent border-l-transparent"
            animate={{ rotate: -360 }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          />
        </span>
      </span>
    </LazyMotion>
  );
};

export default Loader;
